import React from "react";
import PartnerDetailFields from "../PartnerDetailFields/PartnerDetailFields";
import { PartnerData } from "@/pages/partners/types";
import PartnerSections from "@/components/layouts/QuickView/Partner/PartnerSections";
import { DetailedViewOptions } from "@/components/controls/OptionsDropdownMenu/OptionsDropdownMenu";

interface Props {
  partner: PartnerData | undefined;
  onUpdateField: (
    field: string,
    newValue: string | number,
    additionalFields?: {
      [fieldName: string]: string | number;
    },
    successToastText?: string,
    onSuccessFn?: () => void
  ) => void;
  getCreateOptions?: () => DetailedViewOptions;
}

const PartnerOverviewContent: React.FC<Props> = ({
  partner,
  onUpdateField,
  getCreateOptions
}) => {
  return (
    <div className="w-full flex flex-col gap-6">
      <div className="w-full flex gap-6">
        <div className="flex-1">
          <PartnerDetailFields
            partner={partner}
            onUpdateField={(
              field: string,
              newValue: string | number | string[]
            ) => onUpdateField(field, newValue as string | number)}
            containerClassName="grid-cols-[minmax(0,30%),1fr]"
          />
        </div>
        <div className="flex-1 flex flex-col gap-6">
          <PartnerSections partner={partner} getCreateOptions={getCreateOptions} />
        </div>
      </div>
    </div>
  );
};

export default PartnerOverviewContent;
